import { mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  ${mixins.margin.right(90)}
  &:last-child {
    ${mixins.margin.right(0)}
  }
`

export const IconWrapper = styled.div`
  ${mixins.margin.right(10)}
`

export const TextWrapper = styled.div`
  font-size: 10px;
`
